var map = {
	"./About": [
		"en7K",
		2
	],
	"./About.vue": [
		"en7K",
		2
	],
	"./Aboutus": [
		"YDcf",
		6
	],
	"./Aboutus.vue": [
		"YDcf",
		6
	],
	"./EmailVerify": [
		"ChHq",
		24
	],
	"./EmailVerify.vue": [
		"ChHq",
		24
	],
	"./Error": [
		"f2KA",
		49
	],
	"./Error.vue": [
		"f2KA",
		49
	],
	"./HelloWorld": [
		"sK4E",
		32
	],
	"./HelloWorld.vue": [
		"sK4E",
		32
	],
	"./Homepage": [
		"Z7co",
		3
	],
	"./Homepage.vue": [
		"Z7co",
		3
	],
	"./HomepageCategory": [
		"wpfP",
		11
	],
	"./HomepageCategory.vue": [
		"wpfP",
		11
	],
	"./NotFound": [
		"odg4",
		25
	],
	"./NotFound.vue": [
		"odg4",
		25
	],
	"./PasswordReset": [
		"8lW+",
		35
	],
	"./PasswordReset.vue": [
		"8lW+",
		35
	],
	"./PasswordResetSend": [
		"XYSl",
		48
	],
	"./PasswordResetSend.vue": [
		"XYSl",
		48
	],
	"./ProductSolution": [
		"Aa52",
		10
	],
	"./ProductSolution.vue": [
		"Aa52",
		10
	],
	"./Restaurant": [
		"GxUC",
		4,
		0
	],
	"./Restaurant.vue": [
		"GxUC",
		4,
		0
	],
	"./Test": [
		"d04G",
		18
	],
	"./Test.vue": [
		"d04G",
		18
	],
	"./Test/ECPay": [
		"5zB4",
		44
	],
	"./Test/ECPay.vue": [
		"5zB4",
		44
	],
	"./Test/Firestore": [
		"s3tU",
		41
	],
	"./Test/Firestore.vue": [
		"s3tU",
		41
	],
	"./Test/Map": [
		"1vQm",
		27
	],
	"./Test/Map.vue": [
		"1vQm",
		27
	],
	"./Test/StickyHeader": [
		"N7I4",
		52
	],
	"./Test/StickyHeader.vue": [
		"N7I4",
		52
	],
	"./brand/Brand": [
		"1RUY",
		1
	],
	"./brand/Brand.vue": [
		"1RUY",
		1
	],
	"./console/Coin": [
		"OTBM",
		50
	],
	"./console/Coin.vue": [
		"OTBM",
		50
	],
	"./console/News": [
		"EiVR",
		20
	],
	"./console/News.vue": [
		"EiVR",
		20
	],
	"./console/RecommendCode": [
		"IoQr",
		39
	],
	"./console/RecommendCode.vue": [
		"IoQr",
		39
	],
	"./console/ShopList": [
		"tcSn",
		16
	],
	"./console/ShopList.vue": [
		"tcSn",
		16
	],
	"./customer/CustomerAccount": [
		"8ASD",
		46
	],
	"./customer/CustomerAccount.vue": [
		"8ASD",
		46
	],
	"./customer/CustomerCoin": [
		"BJvw",
		37
	],
	"./customer/CustomerCoin.vue": [
		"BJvw",
		37
	],
	"./customer/CustomerHelp": [
		"z5Nw",
		29
	],
	"./customer/CustomerHelp.vue": [
		"z5Nw",
		29
	],
	"./customer/CustomerOrders": [
		"FUuq",
		0,
		7
	],
	"./customer/CustomerOrders.vue": [
		"FUuq",
		0,
		7
	],
	"./privacyRule": [
		"dek0",
		19
	],
	"./privacyRule.vue": [
		"dek0",
		19
	],
	"./serviceRule": [
		"uQfZ",
		36
	],
	"./serviceRule.vue": [
		"uQfZ",
		36
	],
	"./shop/Help": [
		"F6mU",
		51
	],
	"./shop/Help.vue": [
		"F6mU",
		51
	],
	"./shop/ShopAdmin": [
		"mWB5",
		40
	],
	"./shop/ShopAdmin.vue": [
		"mWB5",
		40
	],
	"./shop/ShopAnalysis": [
		"a4yc",
		0,
		15
	],
	"./shop/ShopAnalysis.vue": [
		"a4yc",
		0,
		15
	],
	"./shop/ShopAuthority": [
		"RhL9",
		8
	],
	"./shop/ShopAuthority.vue": [
		"RhL9",
		8
	],
	"./shop/ShopCoin": [
		"VGSa",
		45
	],
	"./shop/ShopCoin.vue": [
		"VGSa",
		45
	],
	"./shop/ShopDiscount": [
		"T6cN",
		0,
		9
	],
	"./shop/ShopDiscount.vue": [
		"T6cN",
		0,
		9
	],
	"./shop/ShopEdit": [
		"+DcX",
		28
	],
	"./shop/ShopEdit.vue": [
		"+DcX",
		28
	],
	"./shop/ShopHistory": [
		"AhsK",
		0,
		42
	],
	"./shop/ShopHistory.vue": [
		"AhsK",
		0,
		42
	],
	"./shop/ShopInfo": [
		"jTLJ",
		38
	],
	"./shop/ShopInfo.vue": [
		"jTLJ",
		38
	],
	"./shop/ShopList": [
		"+8KE",
		22
	],
	"./shop/ShopList.vue": [
		"+8KE",
		22
	],
	"./shop/ShopOrders": [
		"Mk5J",
		0,
		54
	],
	"./shop/ShopOrders.vue": [
		"Mk5J",
		0,
		54
	],
	"./shop/ShopPermission": [
		"DTN7",
		47
	],
	"./shop/ShopPermission.vue": [
		"DTN7",
		47
	],
	"./shop/ShopReservations": [
		"6zY3",
		0,
		55
	],
	"./shop/ShopReservations.vue": [
		"6zY3",
		0,
		55
	],
	"./shop/ShopStock": [
		"wQgU",
		17
	],
	"./shop/ShopStock.vue": [
		"wQgU",
		17
	],
	"./shop/shopBill/ShopBill": [
		"dVRz",
		31
	],
	"./shop/shopBill/ShopBill.vue": [
		"dVRz",
		31
	],
	"./shop/shopBill/ShopCollection": [
		"b/qy",
		14
	],
	"./shop/shopBill/ShopCollection.vue": [
		"b/qy",
		14
	],
	"./shop/shopBill/ShopDetail": [
		"pu32",
		26
	],
	"./shop/shopBill/ShopDetail.vue": [
		"pu32",
		26
	],
	"./shop/shopBill/ShopPayment": [
		"l2/7",
		33
	],
	"./shop/shopBill/ShopPayment.vue": [
		"l2/7",
		33
	],
	"./shop/shopComment": [
		"EZ6/",
		13
	],
	"./shop/shopComment.vue": [
		"EZ6/",
		13
	],
	"./shop/shopMeal/ShopMeal": [
		"7/6k",
		5
	],
	"./shop/shopMeal/ShopMeal.vue": [
		"7/6k",
		5
	],
	"./shop/shopMeal/ShopMealConfirm": [
		"guAq",
		34
	],
	"./shop/shopMeal/ShopMealConfirm.vue": [
		"guAq",
		34
	],
	"./shop/shopMenu/ShopMenu": [
		"flQd",
		30
	],
	"./shop/shopMenu/ShopMenu.vue": [
		"flQd",
		30
	],
	"./shop/shopMenu/ShopMenuCategory": [
		"0ZlZ",
		0,
		12
	],
	"./shop/shopMenu/ShopMenuCategory.vue": [
		"0ZlZ",
		0,
		12
	],
	"./shop/shopMenu/ShopMenuCategoryEdit": [
		"c7Fo",
		0,
		21
	],
	"./shop/shopMenu/ShopMenuCategoryEdit.vue": [
		"c7Fo",
		0,
		21
	],
	"./shop/shopMenu/ShopMenuCustomization": [
		"bvya",
		23
	],
	"./shop/shopMenu/ShopMenuCustomization.vue": [
		"bvya",
		23
	],
	"./shop/shopMenu/ShopMenuSquare": [
		"4LG0",
		0
	],
	"./shop/shopMenu/ShopMenuSquare.vue": [
		"4LG0",
		0
	],
	"./shop/shopMenu/ShopMenuStatus": [
		"DlCQ",
		43
	],
	"./shop/shopMenu/ShopMenuStatus.vue": [
		"DlCQ",
		43
	],
	"./shop/shopResource": [
		"+3p0",
		53
	],
	"./shop/shopResource.vue": [
		"+3p0",
		53
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5BXs";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/pages lazy ^\.\/.*$
// module id = 5BXs
// module chunks = 57